import React, { useState } from 'react';
import { Phone, Pause, ArrowLeft, Camera, Volume2, Mic, MicOff } from 'lucide-react';

const SIPPhoneManual = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    },
    mainWrapper: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '2rem'
    },
    header: {
      textAlign: 'center',
      marginBottom: '3rem',
      padding: '2rem',
      background: 'linear-gradient(135deg, #4299e1 0%, #3182ce 100%)',
      color: 'white',
      borderRadius: '12px'
    },
    headerTitle: {
      fontSize: '2.5rem',
      marginBottom: '0.5rem',
      margin: '0 0 0.5rem 0'
    },
    headerSubtitle: {
      fontSize: '1.2rem',
      opacity: '0.9',
      margin: 0
    },
    section: {
      background: 'white',
      marginBottom: '2rem',
      padding: '2rem',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    },
    sectionTitle: {
      color: '#2d3748',
      fontSize: '1.8rem',
      marginBottom: '1rem',
      borderBottom: '3px solid #4299e1',
      paddingBottom: '0.5rem'
    },
    sectionSubtitle: {
      color: '#4a5568',
      fontSize: '1.4rem',
      margin: '1.5rem 0 1rem 0'
    },
    twoColumn: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '3rem',
      alignItems: 'start'
    },
    phoneContainer: {
      display: 'flex',
      justifyContent: 'center',
      position: 'sticky',
      top: '2rem'
    },
    phoneMockup: {
      width: '280px',
      height: '580px',
      background: '#000',
      borderRadius: '35px',
      position: 'relative',
      boxShadow: '0 15px 30px rgba(0, 0, 0, 0.3)',
      overflow: 'hidden'
    },
    phoneScreen: {
      width: '260px',
      height: '560px',
      background: 'linear-gradient(to bottom, #111, #000)',
      borderRadius: '30px',
      margin: '10px',
      position: 'relative',
      color: 'white',
      fontSize: '12px'
    },
    annotation: {
      position: 'absolute',
      background: '#4299e1',
      color: 'white',
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      fontWeight: 'bold',
      zIndex: 10
    },
    dynamicIsland: {
      width: '120px',
      height: '30px',
      background: '#000',
      borderRadius: '0 0 15px 15px',
      margin: '0 auto',
      position: 'relative'
    },
    islandCameras: {
      position: 'absolute',
      top: '6px',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: '60px'
    },
    camera: {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      background: '#333'
    },
    statusBar: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '1rem',
      fontSize: '11px',
      marginTop: '0.5rem'
    },
    statusIndicators: {
      display: 'flex',
      gap: '3px',
      alignItems: 'center'
    },
    signalDot: {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      background: 'white'
    },
    battery: {
      width: '12px',
      height: '8px',
      background: 'white',
      borderRadius: '2px',
      marginLeft: '3px'
    },
    keypadDisplay: {
      textAlign: 'center',
      padding: '2rem 1rem 1rem'
    },
    phoneNumber: {
      fontSize: '24px',
      marginBottom: '0.5rem',
      color: 'white',
      minHeight: '30px',
      fontWeight: '300'
    },
    helperText: {
      fontSize: '9px',
      color: '#aaa',
      marginBottom: '1rem'
    },
    keypadGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '18px',
      padding: '1rem',
      maxWidth: '220px',
      margin: '0 auto'
    },
    keypadButton: {
      width: '55px',
      height: '55px',
      borderRadius: '50%',
      background: 'transparent',
      border: 'none',
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '24px',
      margin: '0 auto',
      cursor: 'pointer',
      transition: 'background-color 0.2s'
    },
    keypadLetters: {
      fontSize: '8px',
      color: '#777',
      marginTop: '2px',
      fontWeight: '400'
    },
    controlsBottom: {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: '1rem',
      marginTop: '0.5rem'
    },
    pauseButton: {
      width: '45px',
      height: '45px',
      borderRadius: '50%',
      background: 'rgba(255, 255, 255, 0.1)',
      border: 'none',
      color: '#ffa726',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer'
    },
    callButton: {
      width: '55px',
      height: '55px',
      borderRadius: '50%',
      background: '#90c4c3',
      border: 'none',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer'
    },
    backspaceButton: {
      width: '45px',
      height: '45px',
      borderRadius: '50%',
      background: 'rgba(255, 255, 255, 0.1)',
      border: 'none',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer'
    },
    tabInterface: {
      position: 'absolute',
      bottom: '20px',
      left: '10px',
      right: '10px',
      background: '#1a1a1a',
      borderRadius: '20px 20px 0 0',
      padding: '1rem'
    },
    tabs: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      textAlign: 'center'
    },
    tab: {
      fontSize: '12px',
      color: '#777',
      padding: '0.5rem',
      cursor: 'pointer'
    },
    tabActive: {
      fontSize: '12px',
      color: 'white',
      padding: '0.5rem',
      cursor: 'pointer'
    },
    explanationList: {
      listStyle: 'none',
      marginTop: '2rem',
      padding: 0
    },
    explanationItem: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '1.5rem',
      padding: '1rem',
      background: '#f7fafc',
      borderRadius: '8px',
      borderLeft: '4px solid #4299e1'
    },
    explanationNumber: {
      background: '#4299e1',
      color: 'white',
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      fontWeight: 'bold',
      marginRight: '1rem',
      flexShrink: 0
    },
    explanationContent: {
      flex: 1
    },
    explanationTitle: {
      color: '#2d3748',
      marginBottom: '0.5rem',
      fontWeight: 'bold'
    },
    explanationText: {
      color: '#4a5568',
      lineHeight: '1.5',
      margin: 0
    },
    stepList: {
      listStyle: 'none',
      counterReset: 'step-counter',
      padding: 0
    },
    stepItem: {
      counterIncrement: 'step-counter',
      marginBottom: '1rem',
      padding: '1rem',
      background: '#f7fafc',
      borderRadius: '8px',
      position: 'relative',
      paddingLeft: '3rem'
    },
    featureGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '1.5rem',
      margin: '2rem 0'
    },
    featureCard: {
      background: '#f7fafc',
      padding: '1.5rem',
      borderRadius: '8px',
      borderLeft: '4px solid #4299e1'
    },
    featureTitle: {
      color: '#2d3748',
      marginBottom: '0.5rem',
      fontWeight: 'bold'
    },
    featureText: {
      color: '#4a5568',
      fontSize: '0.9rem',
      margin: 0
    },
    infoBox: {
      background: '#bee3f8',
      border: '1px solid #63b3ed',
      borderRadius: '8px',
      padding: '1rem',
      margin: '1rem 0'
    },
    warningBox: {
      background: '#fed7d7',
      border: '1px solid #fc8181',
      borderRadius: '8px',
      padding: '1rem',
      margin: '1rem 0'
    },
    infoTitle: {
      color: '#2b6cb0',
      marginBottom: '0.5rem',
      fontWeight: 'bold'
    },
    warningTitle: {
      color: '#c53030',
      marginBottom: '0.5rem',
      fontWeight: 'bold'
    },
    infoText: {
      color: '#2c5282',
      margin: 0
    },
    warningText: {
      color: '#742a2a',
      margin: 0
    },
    keyboardShortcuts: {
      background: '#f0f4f8',
      borderRadius: '8px',
      padding: '1.5rem',
      margin: '1rem 0'
    },
    shortcutGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '1rem',
      marginTop: '1rem'
    },
    shortcutItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: 'white',
      padding: '0.5rem 1rem',
      borderRadius: '6px',
      border: '1px solid #e2e8f0'
    },
    shortcutKey: {
      background: '#4a5568',
      color: 'white',
      padding: '0.2rem 0.5rem',
      borderRadius: '4px',
      fontSize: '0.8rem',
      fontWeight: 'bold'
    },
    mobileResponsive: {
      '@media (max-width: 768px)': {
        gridTemplateColumns: '1fr',
        gap: '2rem'
      }
    }
  };
  const [displayNumber, setDisplayNumber] = useState('7621004239');
  const [currentTab, setCurrentTab] = useState('Teclado');

  const keypadButtons = [
    { number: '1', letters: '' },
    { number: '2', letters: 'ABC' },
    { number: '3', letters: 'DEF' },
    { number: '4', letters: 'GHI' },
    { number: '5', letters: 'JKL' },
    { number: '6', letters: 'MNO' },
    { number: '7', letters: 'PQRS' },
    { number: '8', letters: 'TUV' },
    { number: '9', letters: 'WXYZ' },
    { number: '*', letters: '' },
    { number: '0', letters: '+' },
    { number: '#', letters: '' }
  ];

  const steps = [
    {
      title: "Marca el número:",
      description: "Usa el teclado numérico para marcar el número deseado. Puedes usar tanto el teclado en pantalla como el teclado físico de tu computadora."
    },
    {
      title: "Verifica el número:",
      description: "El número aparecerá en la pantalla principal. Si te equivocas, usa el botón de borrar (←) para corregir."
    },
    {
      title: "Inicia la llamada:",
      description: "Presiona el botón verde de llamada o la tecla Enter. El teléfono comenzará a marcar."
    },
    {
      title: "Espera la conexión:",
      description: "Verás el estado \"Llamando...\" y escucharás el tono de marcado hasta que la otra persona conteste."
    },
    {
      title: "Conversación:",
      description: "Una vez conectado, puedes hablar normalmente. Usa los controles durante la llamada si es necesario."
    }
  ];

  const features = [
    {
      title: "🔔 Notificación Automática",
      description: "Cuando recibas una llamada, aparecerá una notificación en tu pantalla mostrando el número que te llama."
    },
    {
      title: "🎵 Tono de Timbre",
      description: "Escucharás un tono de timbre estándar que se repetirá hasta que contestes o rechaces la llamada."
    },
    {
      title: "✅ Contestar",
      description: "Presiona el botón verde o la tecla Enter/Espacio para contestar la llamada entrante."
    },
    {
      title: "❌ Rechazar",
      description: "Presiona el botón rojo o la tecla Escape para rechazar la llamada. Se guardará como \"rechazada\" en el historial."
    }
  ];

  const callTypes = [
    {
      title: "📤 Salientes",
      description: "Llamadas que tú realizaste. Se muestran con una flecha hacia arriba en color azul."
    },
    {
      title: "📥 Entrantes",
      description: "Llamadas que contestaste. Se muestran con una flecha hacia abajo en color verde."
    },
    {
      title: "📵 Perdidas",
      description: "Llamadas que no contestaste. Se muestran en color rojo con un punto indicador."
    },
    {
      title: "🚫 Rechazadas",
      description: "Llamadas que rechazaste activamente. Se muestran en color naranja."
    }
  ];

  const shortcuts = [
    { action: "Marcar número", key: "0-9, *, #" },
    { action: "Llamar/Contestar", key: "Enter" },
    { action: "Alternar llamar/colgar", key: "Espacio" },
    { action: "Colgar llamada", key: "Esc" },
    { action: "Borrar último dígito", key: "Backspace" },
    { action: "Limpiar número", key: "Delete" }
  ];

  const callShortcuts = [
    { action: "Silenciar micrófono", key: "M" },
    { action: "Alternar altavoz", key: "S" },
    { action: "Remarcar último", key: "R" },
    { action: "Pausar/Reanudar", key: "P" }
  ];

  const PhoneMockup = () => (
    <div style={styles.phoneContainer}>
      <div style={styles.phoneMockup}>
        {/* Annotations */}
        <div style={{...styles.annotation, top: '80px', right: '-10px'}}>1</div>
        <div style={{...styles.annotation, top: '200px', left: '-10px'}}>2</div>
        <div style={{...styles.annotation, bottom: '120px', left: '-10px'}}>3</div>
        <div style={{...styles.annotation, bottom: '120px', right: '-10px'}}>4</div>
        <div style={{...styles.annotation, bottom: '120px', right: '40px'}}>5</div>
        <div style={{...styles.annotation, bottom: '40px', right: '-10px'}}>6</div>
        
        <div style={styles.phoneScreen}>
          {/* Dynamic Island */}
          <div style={styles.dynamicIsland}>
            <div style={styles.islandCameras}>
              <div style={styles.camera}></div>
              <div style={styles.camera}></div>
            </div>
          </div>

          {/* Status Bar */}
          <div style={styles.statusBar}>
            <span>17:53</span>
            <div style={styles.statusIndicators}>
              <div style={styles.signalDot}></div>
              <div style={styles.signalDot}></div>
              <div style={styles.signalDot}></div>
              <div style={styles.signalDot}></div>
              <div style={styles.battery}></div>
            </div>
          </div>

          {/* Display */}
          <div style={styles.keypadDisplay}>
            <div style={styles.phoneNumber}>{displayNumber}</div>
            <div style={styles.helperText}>Usa el teclado numérico para marcar • Enter para llamar • P para pausar</div>
            
            {/* Keypad */}
            <div style={styles.keypadGrid}>
              {keypadButtons.map((button, index) => (
                <button
                  key={index}
                  style={{
                    ...styles.keypadButton,
                    ':hover': { background: 'rgba(255, 255, 255, 0.1)' }
                  }}
                  onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.1)'}
                  onMouseLeave={(e) => e.target.style.background = 'transparent'}
                >
                  <span>{button.number}</span>
                  {button.letters && <div style={styles.keypadLetters}>{button.letters}</div>}
                </button>
              ))}
            </div>

            {/* Controls */}
            <div style={styles.controlsBottom}>
              <button style={styles.pauseButton}>
                <Pause size={16} />
              </button>
              <button style={styles.callButton}>
                <Phone size={20} />
              </button>
              <button style={styles.backspaceButton}>
                <ArrowLeft size={16} />
              </button>
            </div>
          </div>

          {/* Tab Interface */}
          <div style={styles.tabInterface}>
            <div style={styles.tabs}>
              {['Favoritos', 'Recientes', 'Teclado'].map((tab) => (
                <div
                  key={tab}
                  style={currentTab === tab ? styles.tabActive : styles.tab}
                  onClick={() => setCurrentTab(tab)}
                >
                  {tab}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const Section = ({ title, children, className = "" }) => (
    <div style={{...styles.section, ...(className ? {className} : {})}}>
      <h2 style={styles.sectionTitle}>{title}</h2>
      {children}
    </div>
  );

  const InfoBox = ({ title, children, type = "info" }) => {
    const boxStyle = type === "warning" ? styles.warningBox : styles.infoBox;
    const titleStyle = type === "warning" ? styles.warningTitle : styles.infoTitle;
    const textStyle = type === "warning" ? styles.warningText : styles.infoText;
    
    return (
      <div style={boxStyle}>
        <h4 style={titleStyle}>{title}</h4>
        <p style={textStyle}>{children}</p>
      </div>
    );
  };

  const FeatureGrid = ({ features }) => (
    <div style={styles.featureGrid}>
      {features.map((feature, index) => (
        <div key={index} style={styles.featureCard}>
          <h4 style={styles.featureTitle}>{feature.title}</h4>
          <p style={styles.featureText}>{feature.description}</p>
        </div>
      ))}
    </div>
  );

  const StepList = ({ steps }) => (
    <ol style={styles.stepList}>
      {steps.map((step, index) => (
        <li key={index} style={styles.stepItem}>
          <div style={{
            ...styles.explanationNumber,
            position: 'absolute',
            left: '1rem',
            top: '1rem'
          }}>
            {index + 1}
          </div>
          <div style={{paddingLeft: '1rem'}}>
            <strong>{step.title}</strong> {step.description}
          </div>
        </li>
      ))}
    </ol>
  );

  const ShortcutGrid = ({ shortcuts }) => (
    <div style={styles.shortcutGrid}>
      {shortcuts.map((shortcut, index) => (
        <div key={index} style={styles.shortcutItem}>
          <span>{shortcut.action}</span>
          <span style={styles.shortcutKey}>{shortcut.key}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={styles.mainWrapper}>
        {/* Header */}
        <div style={styles.header}>
          <h1 style={styles.headerTitle}>📞 Manual de Usuario</h1>
          <p style={styles.headerSubtitle}>Teléfono SIP - Guía Completa para Usuarios</p>
        </div>

        {/* Introducción */}
        <Section title="🎯 Introducción">
          <p style={{marginBottom: '1rem'}}>Bienvenido al sistema de Teléfono SIP. Esta aplicación te permite realizar y recibir llamadas telefónicas directamente desde tu navegador web, funcionando como un teléfono tradicional pero con funciones avanzadas.</p>
          
          <InfoBox title="💡 ¿Qué es SIP?">
            SIP (Session Initiation Protocol) es un protocolo que permite hacer llamadas por internet. Nuestro teléfono funciona como un smartphone, pero desde tu computadora.
          </InfoBox>
        </Section>

        {/* Conociendo la Interfaz */}
        <Section title="🖥️ Conociendo la Interfaz">
          <div style={window.innerWidth > 768 ? styles.twoColumn : {display: 'block'}}>
            <div>
              <h3 style={styles.sectionSubtitle}>Elementos Principales</h3>
              <div style={styles.explanationList}>
                {[
                  { num: 1, title: "Número Marcado", desc: "Aquí aparece el número que estás marcando. Se actualiza automáticamente mientras presionas los botones del teclado." },
                  { num: 2, title: "Teclado Numérico", desc: "Funciona igual que un teléfono tradicional. Incluye números del 0-9, asterisco (*) y numeral (#). Cada botón también muestra las letras correspondientes." },
                  { num: 3, title: "Botón de Pausa", desc: "Te permite pausar o reanudar las llamadas entrantes. Útil cuando necesitas un descanso o estás ocupado." },
                  { num: 4, title: "Botón de Llamada", desc: "Botón verde para iniciar la llamada. Solo se activa cuando has marcado un número válido." },
                  { num: 5, title: "Botón Borrar", desc: "Elimina el último dígito marcado. Manténlo presionado para borrar todo el número." },
                  { num: 6, title: "Menú de Pestañas", desc: "Cambia entre Favoritos, Recientes y Teclado. En \"Recientes\" verás las últimas 50 llamadas realizadas y recibidas." }
                ].map((item) => (
                  <div key={item.num} style={styles.explanationItem}>
                    <div style={styles.explanationNumber}>
                      {item.num}
                    </div>
                    <div style={styles.explanationContent}>
                      <h4 style={styles.explanationTitle}>{item.title}</h4>
                      <p style={styles.explanationText}>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <PhoneMockup />
          </div>
        </Section>

        {/* Cómo Realizar una Llamada */}
        <Section title="📞 Cómo Realizar una Llamada">
          <StepList steps={steps} />
          
          <InfoBox title="💡 Consejo">
            Para números de México de 10 dígitos, el sistema automáticamente agregará el prefijo "52" al marcar números internacionales.
          </InfoBox>
        </Section>

        {/* Recibir Llamadas */}
        <Section title="📱 Recibir Llamadas">
          <FeatureGrid features={features} />
          
          <InfoBox title="⚠️ Permisos del Navegador" type="warning">
            Para recibir notificaciones de llamadas entrantes, debes permitir las notificaciones cuando el navegador te lo solicite. Sin esto, no verás notificaciones cuando tengas otras ventanas abiertas.
          </InfoBox>
        </Section>

        {/* Controles Durante la Llamada */}
        <Section title="🎛️ Controles Durante la Llamada">
          <FeatureGrid features={[
            {
              title: "🔇 Silenciar Micrófono",
              description: "Presiona el botón de micrófono o la tecla \"M\" para silenciar/activar tu micrófono durante la llamada."
            },
            {
              title: "🔊 Altavoz",
              description: "Usa el botón de altavoz o la tecla \"S\" para cambiar entre auricular y altavoz (función simulada)."
            },
            {
              title: "🔢 Teclado DTMF",
              description: "Durante la llamada, puedes presionar números para enviar tonos DTMF (útil para menús telefónicos automatizados)."
            },
            {
              title: "📵 Finalizar Llamada",
              description: "Presiona el botón rojo o las teclas Escape/Backspace para terminar la llamada."
            }
          ]} />
        </Section>

        {/* Historial de Llamadas */}
        <Section title="📋 Historial de Llamadas">
          <p style={{marginBottom: '1.5rem'}}>El teléfono mantiene un registro automático de todas tus llamadas en la pestaña "Recientes".</p>
          
          <h3 style={styles.sectionSubtitle}>Tipos de Llamadas</h3>
          <FeatureGrid features={callTypes} />

          <h3 style={styles.sectionSubtitle}>Funciones del Historial</h3>
          <StepList steps={[
            { title: "Llamar desde historial:", description: "Haz clic en cualquier entrada del historial para marcar ese número automáticamente." },
            { title: "Límite de registros:", description: "Se mantienen las últimas 50 llamadas. Las más antiguas se eliminan automáticamente." },
            { title: "Borrar historial:", description: "Usa el botón \"Borrar\" en la parte superior derecha para limpiar todo el historial." },
            { title: "Información de tiempo:", description: "Cada llamada muestra cuándo ocurrió (hoy, ayer, o fecha específica)." }
          ]} />
        </Section>

        {/* Sistema de Pausa */}
        <Section title="⏸️ Sistema de Pausa">
          <p style={{marginBottom: '1.5rem'}}>La función de pausa te permite controlar cuándo puedes recibir llamadas entrantes.</p>

          <FeatureGrid features={[
            {
              title: "⏸️ Pausar",
              description: "Cuando actives la pausa, no recibirás llamadas entrantes. Útil durante descansos o cuando estás ocupado."
            },
            {
              title: "▶️ Reanudar",
              description: "Al reanudar, volverás a recibir llamadas normalmente. El sistema te marcará como \"Disponible\"."
            },
            {
              title: "🎯 Estados",
              description: "El sistema distingue entre \"Disponible\" (activo) y \"Offline\" (pausado) para el control de llamadas."
            },
            {
              title: "⌨️ Atajo de Teclado",
              description: "Presiona la tecla \"P\" para alternar rápidamente entre pausado y disponible."
            }
          ]} />

          <InfoBox title="💡 ¿Cuándo usar la pausa?">
            Usa la pausa durante tus descansos, al final del día, o cuando necesites tiempo para completar tareas administrativas sin interrupciones.
          </InfoBox>
        </Section>

        {/* Atajos de Teclado */}
        <Section title="⌨️ Atajos de Teclado">
          <p style={{marginBottom: '1.5rem'}}>Puedes usar tu teclado físico para controlar el teléfono de manera más eficiente:</p>
          
          <div style={styles.keyboardShortcuts}>
            <h4 style={{fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '1rem'}}>🎯 Atajos Principales</h4>
            <ShortcutGrid shortcuts={shortcuts} />
            
            <h4 style={{fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '1rem', marginTop: '2rem'}}>🎛️ Durante Llamadas</h4>
            <ShortcutGrid shortcuts={callShortcuts} />
          </div>
        </Section>

        {/* Solución de Problemas */}
        <Section title="🔧 Solución de Problemas">
          <h3 style={styles.sectionSubtitle}>Problemas Comunes</h3>
          
          <div style={{marginBottom: '1rem'}}>
            <InfoBox title="🔴 No puedo hacer llamadas" type="warning">
              <strong>Solución:</strong> Verifica que el estado del teléfono sea "Listo". Si aparece "Desconectado", actualiza la página o contacta al soporte técnico.
            </InfoBox>

            <InfoBox title="🔇 No escucho audio" type="warning">
              <strong>Solución:</strong> Verifica que tu navegador tenga permisos de micrófono y audio. Asegúrate de que el volumen de tu sistema esté activado.
            </InfoBox>

            <InfoBox title="🔔 No recibo notificaciones" type="warning">
              <strong>Solución:</strong> Permite las notificaciones cuando el navegador te lo solicite. Ve a la configuración de tu navegador y habilita las notificaciones para este sitio.
            </InfoBox>

            <InfoBox title="⌨️ El teclado no funciona" type="warning">
              <strong>Solución:</strong> Haz clic en cualquier parte del teléfono para asegurar que tenga el foco. Los atajos de teclado solo funcionan cuando el teléfono está activo.
            </InfoBox>
          </div>

          <h3 style={styles.sectionSubtitle}>Contacto de Soporte</h3>
          <InfoBox title="🆘 ¿Necesitas ayuda?">
            Si experimentas problemas técnicos o tienes preguntas sobre el uso del teléfono, contacta al equipo de soporte técnico de tu organización.
          </InfoBox>
        </Section>

        {/* Consejos y Mejores Prácticas */}
        <Section title="🎯 Consejos y Mejores Prácticas">
          <FeatureGrid features={[
            {
              title: "🔊 Calidad de Audio",
              description: "Usa auriculares con micrófono para mejor calidad de audio y reducir el eco durante las llamadas."
            },
            {
              title: "🌐 Conexión Estable",
              description: "Mantén una conexión a internet estable. Una conexión lenta puede afectar la calidad de las llamadas."
            },
            {
              title: "🔄 Actualización Regular",
              description: "Actualiza tu navegador regularmente para asegurar la mejor compatibilidad con el teléfono SIP."
            },
            {
              title: "📝 Historial de Llamadas",
              description: "Revisa regularmente tu historial de llamadas para no perder llamadas importantes sin devolver."
            }
          ]} />

          <InfoBox title="✨ Funciones Avanzadas">
            Experimenta con los atajos de teclado para aumentar tu productividad. Una vez que te acostumbres, podrás manejar las llamadas mucho más rápidamente.
          </InfoBox>
        </Section>
      </div>
    </div>
  );
};

export default SIPPhoneManual;